<!-- App.vue -->
<template>
	<div id="suduko">
		<div
			id="hideinmobile"
			class="d-flex w-100 justify-content-center align-items-center gap-4 mt-4"
		>
			<h1 id="title" class="mr-4">Sudoku</h1>
			<article>
				<h5>Timer</h5>
				<h4>{{ formattedTime }}</h4>
			</article>
			<article>
				<h5>Best time</h5>
				<h4>{{ bestTry }}</h4>
			</article>
		</div>
		<div
			id="hideinlaptop"
			class="d-flex w-100 justify-content-center align-items-center gap-4 mt-4"
		>
			<article>
				<h5>Current score</h5>
				<h4>{{ formattedTime }}</h4>
			</article>
			<article>
				<h5>Best try</h5>
				<h4>{{ bestTry }}</h4>
			</article>
		</div>
		<div id="main" class="position-relative">
			<div v-for="row in 3" :key="'row' + row" :id="'row' + row" class="row">
				<div
					v-for="col in 3"
					:key="'box' + ((row - 1) * 3 + col)"
					:id="'box' + ((row - 1) * 3 + col)"
					class="box"
				>
					<div v-for="i in 9" :key="i" class="cell">
						<input
							type="tel"
							autocomplete="off"
							:id="(((row - 1) * 3 + col - 1) * 9 + i).toString()"
							class="input"
							v-model="board[((row - 1) * 3 + col - 1) * 9 + i - 1]"
							:readonly="isReadOnly[((row - 1) * 3 + col - 1) * 9 + i - 1]"
							maxlength="1"
							pattern="[0-9]"
							:style="
								isReadOnly[((row - 1) * 3 + col - 1) * 9 + i - 1]
									? 'color:black;'
									: 'color:blue;'
							"
							@input="
								(event) => {
									validateInput(event, ((row - 1) * 3 + col - 1) * 9 + i - 1);
								}
							"
							@keypress="onlyAllowDigits($event)"
							@touchstart="onTouchStart($event)"
							@keydown="
								(event) =>
									handleKeyDown(event, ((row - 1) * 3 + col - 1) * 9 + i - 1)
							"
						/>
					</div>
				</div>
			</div>
			<div
				:class="{ 'opac-5 pointer-none': submitted || answerReveled }"
				class="reset-game-hover reset-suduko-hover"
				@click="submitted || answerReveled ? '' : (showReset = true)"
			>
				<img
					src="../../assets/newdesign/dashboard/games/reset-game.svg"
					alt=""
				/>
				<span class="pr-3 ml-2">Reset game</span>
			</div>
			<div
				class="hint-game-hover hint-suduko-hover"
				:class="{ 'opac-5 pointer-none': submitted || answerReveled }"
				@click="submitted || answerReveled ? '' : showHint()"
			>
				<img
					src="../../assets/newdesign/dashboard/games/hint-game.svg"
					alt=""
				/>

				<span class="pr-3 ml-2">
					<div class="mr-1" id="hideinmobile">Show</div>
					Hint ({{ hintsRemaining }})
				</span>
			</div>
		</div>
		<b-button
			class="pg-addBtn suduko-mt"
			:disabled="submitted || (!allCellsFilled && !answerReveled)"
			@click="answerReveled ? startNewGame() : submitSolution()"
		>
			{{ answerReveled ? "New Game" : "Submit" }}
		</b-button>
		<b-button
			class="pg-addBtn suduko-mt-2"
			:disabled="answerReveled"
			@click="showAnswer"
		>
			Reveal
		</b-button>
		<!-- <b-button
			class="pg-addBtn suduko-mt"
			@click="startNewGame"
		>
			New Game
		</b-button> -->
		<ResetModal
			v-if="showReset"
			:showReset="showReset"
			@close-modal="showReset = false"
			@resetGame="resetGame"
		/>
	</div>
</template>

<script>
import gamesScore from "@/components/mixin/gamesScore";
import { getGameState, saveActivity } from "@/utils/apiFunctions";
import ResetModal from "./ResetModal.vue";
export default {
	name: "App",
	mixins: [gamesScore],
	data() {
		return {
			showReset: false,
			submitted: false,
			board: Array(81).fill(""),
			isReadOnly: Array(81).fill(false),
			resultMessage: {
				title: "",
				message: "",
				success: false,
				stats: null,
			},
			difficulty: "medium",
			timer: null,
			savedGameDetails: null,
			saveDebounceTimeout: null,
			secondsElapsed: 0, // Initial value in seconds
			// currentPuzzleIndex: 0,
			mistakes: 0,
			hintsRemaining: 3, // Number of hints allowed per game
			hintCooldown: false, // To prevent hint spam
			gameOver: false,
			gameWon: false,
			gameCompleted: false,
			gameStarted: false,
			showSavedGameModal: false,
			answerReveled: false,
			showResult: false,
			showExitModal: false,
			isInitialLoad: true,
			currentSeries: 0,
			solution: null,
			domUpdated: false,
			allCellsFilled: false,
		};
	},
	props: {
		back: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		ResetModal,
	},
	mounted() {
		this.startActivityTimer();
		window.addEventListener("beforeunload", this.saveStateOnReload);
	},
	async created() {
		await this.checkForSavedGame();
		this.startTimer();
		if (this.answerReveled) {
			clearInterval(this.timer);
			this.allCellsFilled = true;
		}
		window.addEventListener("popstate", this.handlePopState);
	},
	beforeDestroy() {
		window.removeEventListener("beforeunload", this.saveStateOnReload);
		clearInterval(this.activityInterval);
		if (this.timer) {
			this.saveGame();
			clearInterval(this.timer);
		}
		const currentBoard = this.board.join("");
		if (currentBoard.length !== 81) {
			this.saveGame();
		}
	},
	computed: {
		formattedTime() {
			let hours = Math.floor(this.secondsElapsed / 3600);
			let minutes = Math.floor((this.secondsElapsed % 3600) / 60);
			let seconds = this.secondsElapsed % 60;
			return (
				String(hours).padStart(2, "0") +
				":" +
				String(minutes).padStart(2, "0") +
				":" +
				String(seconds).padStart(2, "0")
			);
		},
	},

	methods: {
		handleKeyDown(event, currentIndex) {
			const key = event.key;

			if (!["ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown"].includes(key)) {
				return; // Let other keys (including Tab) behave normally
			}

			event.preventDefault();

			const allInputs = [...document.querySelectorAll(".input")];
			const currentInputIndex = allInputs.findIndex(
				(input) => input.id === (currentIndex + 1).toString()
			);

			let nextInput;

			switch (key) {
				case "ArrowRight":
					const currentRectRight =
						allInputs[currentInputIndex].getBoundingClientRect();
					nextInput = allInputs.slice(currentInputIndex + 1).find((input) => {
						const rect = input.getBoundingClientRect();
						return (
							Math.abs(rect.top - currentRectRight.top) < 5 &&
							rect.left > currentRectRight.left
						);
					});

					if (!nextInput) {
						nextInput = allInputs.slice(0, currentInputIndex).find((input) => {
							const rect = input.getBoundingClientRect();
							return (
								Math.abs(rect.top - currentRectRight.top) < 5 &&
								rect.left < currentRectRight.left
							);
						});
					}
					break;

				case "ArrowLeft":
					const currentRectLeft =
						allInputs[currentInputIndex].getBoundingClientRect();
					nextInput = allInputs
						.slice(0, currentInputIndex)
						.reverse()
						.find((input) => {
							const rect = input.getBoundingClientRect();
							return (
								Math.abs(rect.top - currentRectLeft.top) < 5 &&
								rect.left < currentRectLeft.left
							);
						});

					if (!nextInput) {
						nextInput = allInputs.slice(currentInputIndex + 1).find((input) => {
							const rect = input.getBoundingClientRect();
							return (
								Math.abs(rect.top - currentRectLeft.top) < 5 &&
								rect.left > currentRectLeft.left
							);
						});
					}
					break;
				case "ArrowUp": {
					const currentRectUp =
						allInputs[currentInputIndex].getBoundingClientRect();
					nextInput = allInputs
						.slice(0, currentInputIndex)
						.reverse()
						.find((input) => {
							const rect = input.getBoundingClientRect();
							return (
								Math.abs(rect.left - currentRectUp.left) < 5 &&
								rect.top < currentRectUp.top
							);
						});

					if (!nextInput) {
						nextInput = allInputs.slice(currentInputIndex + 1).find((input) => {
							const rect = input.getBoundingClientRect();
							return (
								Math.abs(rect.left - currentRectUp.left) < 5 &&
								rect.top > currentRectUp.top
							);
						});
					}
					break;
				}

				case "ArrowDown": {
					const currentRectDown =
						allInputs[currentInputIndex].getBoundingClientRect();
					nextInput = allInputs.slice(currentInputIndex + 1).find((input) => {
						const rect = input.getBoundingClientRect();
						return (
							Math.abs(rect.left - currentRectDown.left) < 5 &&
							rect.top > currentRectDown.top
						);
					});

					if (!nextInput) {
						nextInput = allInputs.slice(0, currentInputIndex).find((input) => {
							const rect = input.getBoundingClientRect();
							return (
								Math.abs(rect.left - currentRectDown.left) < 5 &&
								rect.top < currentRectDown.top
							);
						});
					}
					break;
				}
			}
			// Focus and select the next input if found
			if (nextInput) {
				nextInput.focus();
				nextInput.select();
			}
		},
		showHint() {
			if (this.hintsRemaining <= 0) {
				return;
			}

			if (this.hintCooldown) {
				return;
			}

			const solution = this.solution;
			const incorrectCells = [];

			// Find cells that are incorrect
			for (let i = 0; i < 81; i++) {
				if (this.board[i] !== solution[i] && !this.isReadOnly[i]) {
					incorrectCells.push(i);
				}
			}

			if (incorrectCells.length === 0) {
				// No incorrect cells found, all cells are correct
				this.showResultMessage({
					title: "No Incorrect Cells",
					message: "All cells are correct!",
					success: true,
				});
				return;
			}

			// Choose a random incorrect cell to reveal
			const randomIndex = Math.floor(Math.random() * incorrectCells.length);
			const cellToReveal = incorrectCells[randomIndex];

			this.$set(this.board, cellToReveal, solution[cellToReveal]);
			this.$set(this.isReadOnly, cellToReveal, true);

			// Update the cell's appearance
			const input = document.getElementById((cellToReveal + 1).toString());
			if (input) {
				input.style.color = "green"; // Highlight the hint number in green
			}

			this.hintsRemaining--;

			this.hintCooldown = true;
			setTimeout(() => {
				this.hintCooldown = false;
			}, 1000); // 1 second cooldown

			this.saveGame();
		},
		startActivityTimer() {
			this.activityInterval = setInterval(async () => {
				await saveActivity("sudoku");
			}, 30000);
		},
		saveStateOnReload() {
			this.saveGame();
		},
		resetGame() {
			this.gameCompleted = false;
			for (let i = 0; i < 81; i++) {
				if (!this.isReadOnly[i]) {
					this.$set(this.board, i, "");
					const input = document.getElementById((i + 1).toString());
					// if (input) {
					// 	input.style.color = "green";
					// }
				}
			}
			if (this.gameStarted) {
				this.saveGame();
			}
			setTimeout(() => {
				this.showReset = false;
			}, 1000);
		},
		onTouchStart(event) {
			event.target.focus();
			event.preventDefault();
		},
		async checkForSavedGame() {
			// await this.deleteGameState("sudoku");
			await this.getMyRank("sudoku");
			const savedGame = await getGameState("sudoku");
			if (savedGame.status == 200) {
				this.savedGameDetails = savedGame.data.data.state;
				this.currentSeries = savedGame.data.data.serial || 0;
				this.loadSavedGame();
			} else {
				this.secondsElapsed = 1;
				this.startNewGame();
			}
			this.isInitialLoad = false;
			this.$emit("gameLoaded");
		},

		handlePopState(e) {
			if (this.gameStarted) {
				e.preventDefault();
				this.showExitModal = true;
				history.pushState(null, "", window.location.pathname);
			}
		},

		async saveGame() {
			const gameState = {
				board: this.board,
				solution: this.solution,
				isReadOnly: this.isReadOnly,
				difficulty: this.difficulty,
				// currentPuzzleIndex: this.currentPuzzleIndex,
				mistakes: this.mistakes,
				hintsRemaining: this.hintsRemaining,
				gameOver: this.gameOver,
				gameWon: this.gameWon,
				reveal: this.answerReveled,
				currentTime: this.secondsElapsed,
				savedAt: new Date().toISOString(),
			};
			this.gameCompleted =
				this.board.length === 81 && this.board.every((cell) => cell !== "")
					? true
					: false;
			this.saveGameState("sudoku", gameState);
		},

		loadSavedGame() {
			if (!this.savedGameDetails) return;

			// Load all saved game properties
			this.board =
				this.savedGameDetails.board || this.savedGameDetails.game_data?.sudoku;
			this.solution =
				this.savedGameDetails.solution ||
				this.savedGameDetails.game_data?.solution;
			this.answerReveled = this.savedGameDetails.reveal || false;
			// this.board = DIFFICULTY_BOARDS[this.difficulty][this.currentPuzzleIndex];

			if (typeof this.board === "string") {
				const cell = [];
				for (let char of this.board) {
					cell.push(char === "-" ? "" : char);
				}
				this.board = cell;
			}
			this.isReadOnly =
				this.savedGameDetails.isReadOnly ||
				this.board.map((cell) => cell !== "");
			this.difficulty = this.savedGameDetails.difficulty || "medium";
			this.hintsRemaining = this.savedGameDetails.hintsRemaining ?? 3;
			this.currentTime = this.savedGameDetails.currentTime;
			this.secondsElapsed = parseInt(this.currentTime, 10) || 0;
			// Start the game
			this.gameStarted = true;
			this.startTimer();
			this.showSavedGameModal = false;
			this.gameCompleted =
				this.board.length === 81 && this.board.every((cell) => cell !== "")
					? true
					: false;
		},
		saveAndExit() {
			this.saveGame();
			this.performExit();
		},

		exitWithoutSaving() {
			this.deleteGameState("sudoku");
			this.performExit();
		},

		continueGame() {
			this.showExitModal = false;
		},

		performExit() {
			clearInterval(this.timer);
			this.showExitModal = false;
			window.location.replace("/games");
		},

		formatDate(dateString) {
			const date = new Date(dateString);
			return date.toLocaleString();
		},

		validateInput(event, index) {
			this.domUpdated = false;
			event.preventDefault();
			if (!/^[1-9]$/.test(event.target.value)) {
				event.target.value = "";
			}

			const value = event.target.value.slice(-1);
			if (value === "" || /^\d$/.test(value)) {
				this.$set(this.board, index, value);
				this.allCellsFilled = this.board.every((cell) => cell !== "");

				if (!this.isReadOnly[index]) {
					event.target.style.color = "blue";
				}

				if (this.gameStarted) {
					if (this.saveDebounceTimeout) {
						clearTimeout(this.saveDebounceTimeout);
					}
					this.saveDebounceTimeout = setTimeout(() => {
						this.saveGame();
					}, 500); // Wait 500ms after the last input before saving
				}
			} else {
				event.target.value = ""; // Clear invalid input
			}
		},

		onlyAllowDigits(event) {
			const charCode = event.charCode || event.keyCode;
			// Allow only digits (0-9)
			if (charCode < 49 || charCode > 57) {
				event.preventDefault();
			}
		},

		async submitSolution() {
			this.domUpdated = true;
			const solution = this.solution;
			// const solution = SOLUTIONS[this.difficulty][this.currentPuzzleIndex];
			const currentBoard = this.board.join("");

			// if (currentBoard.length !== 81) {
			// 	// this.showResultMessage({
			// 	// 	title: "Incomplete Solution",
			// 	// 	message: "Please fill in all the cells before submitting!",
			// 	// 	success: false,
			// 	// });
			// 	alert("Please fill in all the cells before submitting!");
			// 	return;
			// }

			if (currentBoard.trim() === solution.trim()) {
				clearInterval(this.timer);
				this.submitted = true;
				this.gameOver = true;
				this.gameWon = true;
				await this.saveGame();
				setTimeout(async () => {
					const submitted = await this.submitScore(
						"sudoku",
						this.secondsElapsed
					);
					const gameWon = this.gameWon;
					this.$emit("gameOver", gameWon, this.secondsElapsed);
					this.showResultMessage({
						title: "Congratulations! 🎉",
						message: "You solved the puzzle correctly!",
						success: true,
						stats: true,
					});
				}, 1000);
			} else {
				console.log("The mistake count is", this.mistakes);
				this.mistakes++;
				let incorrectCells = 0;
				for (let i = 0; i < 81; i++) {
					if (currentBoard[i] !== solution[i]) {
						incorrectCells++;
					}
				}
			}
		},

		showResultMessage(message) {
			this.resultMessage = message;
			this.showResult = true;
		},

		closeModal() {
			this.showResult = false;
		},

		start() {
			if (this.gameStarted) return;

			this.hintsRemaining = 3;
			this.gameStarted = true;
			// this.currentPuzzleIndex = Math.floor(Math.random() * 5);
			this.mistakes = 0;

			// Fill the board
			for (let i = 0; i < 81; i++) {
				if (puzzle[i] !== "-") {
					this.board[i] = puzzle[i];
					this.isReadOnly[i] = true;
				} else {
					this.board[i] = "";
					this.isReadOnly[i] = false;
				}
			}

			this.startTimer();
		},
		startTimer() {
			clearInterval(this.timer);
			this.timer = setInterval(() => {
				this.secondsElapsed += 1;
			}, 1000);
		},
		startNewGame() {
			// Clear saved game
			this.allCellsFilled = false;
			this.deleteGameState("sudoku");
			this.showSavedGameModal = false;
			this.checkForSavedGame();
			// this.start();
		},
		replay() {
			clearInterval(this.timer);
			this.board = Array(81).fill("");
			this.isReadOnly = Array(81).fill(false);
			this.gameStarted = false;
			this.mistakes = 0;
			this.showResult = false;
			this.gameStarted = false;
			this.difficulty = "easy";
		},

		showAnswer() {
			if (!this.gameStarted) {
				alert("First choose the game and start it!");
				return;
			}
			clearInterval(this.timer);
			const solution = this.solution;
			for (let i = 0; i < 81; i++) {
				this.board[i] = solution[i];
			}
			this.answerReveled = true;
			this.saveGame();
		},
	},
	updated() {
		if (this.domUpdated) {
			let incorrectCells = 0;
			const solution = this.solution;
			// const solution = SOLUTIONS[this.difficulty][this.currentPuzzleIndex];
			const currentBoard = this.board.join("");

			for (let i = 0; i < 81; i++) {
				const input = document.getElementById((i + 1).toString());
				if (input && !this.isReadOnly[i]) {
					input.style.color = "green"; // Reset to default input color
				}
			}

			for (let i = 0; i < 81; i++) {
				if (!this.isReadOnly[i]) {
					const input = document.getElementById((i + 1).toString());
					if (input) {
						if (currentBoard[i] === solution[i]) {
							input.style.color = "#green"; // Blue for correct numbers
						} else {
							input.style.color = "#ff0000"; // Red for incorrect numbers
							incorrectCells++;
						}
					}
				}
			}
		}
	},
};
</script>

<style>
#suduko {
	font-family: Arial, sans-serif;
	display: flex;
	align-items: center;
	flex-direction: column;
	height: 100%;
	box-sizing: border-box;
	overflow: auto;
}

#suduko #title {
	font-size: 32px;
	font-weight: 900;
	font-family: "Lato", sans-serif;
	color: var(--bg-proTheme);
}

.font-24 {
	font-size: 24px;
	font-weight: 600;
}

#suduko article {
	backdrop-filter: blur(4px);
	background-color: #d9e4f5;
	border-radius: 8px;
	padding: 10px;
	width: 120px;
	height: 75px;
	text-align: center;
}

#suduko article h5 {
	font-family: "Lato", sans-serif;
	font-size: var(--sixe-14);
	font-weight: var(--weight-LM);
	color: #595959;
}

#suduko article h4 {
	font-family: Lato;
	font-size: var(--sixe-20);
	font-weight: 900;
	color: var(--bg-proTheme);
	margin-bottom: 0;
}

/* Sudoku Grid Container */
#main {
	display: flex;
	flex-direction: row;
	margin: 20px 0;
	border: 2px solid #20639b;
}

/* Rows within the Sudoku Grid */
.row {
	margin: 0;
}
#row1,
#row2,
#row3 {
	display: grid;
	/* display: flex; */
	/* justify-content: center; */
}

/* Individual Boxes */
.box {
	width: 140px;
	height: 140px;
	border: 2px solid #20639b;
	gap: 1.5px;
	background-color: #d4d9e0;
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-template-rows: repeat(3, 1fr);
	padding: 0;
}

/* Input Cells Inside Each Box */
.cell {
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: #f0f4f8;
	border: 1px solid #a9a9a9;
	border-radius: 2px;
}

/* Input Fields */
.input {
	width: 100%;
	height: 100%;
	font-size: 21px;
	font-weight: 700;
	text-align: center;
	border: none;
	outline: none;
	font-family: "Montserrat", sans-serif;
	background-color: transparent;
}
.input:focus {
	background-color: #b3d1e7;
}
.input-black {
	color: #333333;
}
.input-blue {
	color: #20639b;
}
.input-green {
	color: #28a745;
}
.input-red {
	color: #ff4d4d;
}

/* Buttons */
/* button {
	padding: 10px 20px;
	font-size: 16px;
	background-color: #333;
	color: white;
	border: none;
	cursor: pointer;
	border-radius: 5px;
	transition: background-color 0.3s ease;
}

button:hover {
	background-color: #555;
}

button:active {
	background-color: #222;
} */

/* Game Options */
#game_type {
	margin-top: 20px;
	background-color: #fafafa;
	padding: 20px;
	border-radius: 8px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

h3 {
	margin-bottom: 10px;
}

.label {
	margin-right: 15px;
	font-size: 16px;
}

/* Timer */
#timer {
	margin-top: 20px;
	font-size: 18px;
	font-weight: bold;
}

/* .modal {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1000;
} */

/* .modal-content {
	background-color: white;
	padding: 20px;
	border-radius: 8px;
	max-width: 400px;
	text-align: center;
} */

.result-stats {
	margin: 15px 0;
	padding: 10px;
	background-color: #f5f5f5;
	border-radius: 4px;
}
.close-icon {
	position: absolute;
	top: 1%;
	right: 1%;
}
.suduko-mt {
	margin-bottom: 30px;
}
.suduko-mt-2 {
	margin-bottom: 30px;
}
/* Responsive Design */
@media (max-width: 1028px) {
	.box {
		width: 104px;
		height: 104px;
	}
	.input {
		font-size: 16px;
	}
	button {
		font-size: 14px;
		padding: 8px 15px;
	}
	#game_type {
		padding: 10px;
	}
	h1 {
		font-size: 24px;
	}
	#suduko article {
		width: 150px;
	}
	.suduko-mt {
		margin-top: 70px;
		margin-bottom: 30px;
	}
	.suduko-mt-2 {
		margin-top: 0px;
		margin-bottom: 30px;
	}
	.reset-suduko-hover {
		left: 160px;
	}
	.hint-suduko-hover {
		left: -2px;
	}
}
</style>
